import {
  OnboardingAllResponseModel,
  OnboardingAllResponseApiModel,
} from './onboardingAll.model';

export const onboardingAllAdapter = ({
  data: { data },
}: OnboardingAllResponseApiModel): OnboardingAllResponseModel => data;
